<script>
export default {
  inject:["gsap"],
  name: "FaqWork",
  props:{
    work: Array,
    title: String,
    page: String
  },
  methods:{
    addClass(item){
      let className = item.color

      if(item.mobile_uniq === true){
        className += " uniq"
      }
      return className
    }
  },
  mounted() {
    var element = $(".how-work")
    this.gsap.to('.how-work', {
      duration: 4,
      scrollTrigger: {
        trigger: element, // Элемент, который будет триггером
        start: "top center", // Когда триггер сработает (например, когда верх элемента достигнет центра экрана)
        toggleClass: "active",
        once:true
      }
    });
  }
}
</script>

<template>
  <div class="how-work other left" :class="page">
    <h1 class="flex flex-xy-center">{{ title }}</h1>
    <svg class="green_svg_work" width="1920" height="447" viewBox="0 0 1920 447" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M-86 436C530 79.5 840.105 182.302 956 255C1231 427.501 1523.5 381.5 1747 292C1970.5 202.5 2050.48 10.6072 2052 4" stroke="#B2DBBF" stroke-width="24"/>
    </svg>

    <div class="how-work-cards other left flex flex-column">
      <div class="work-card other left flex flex-column"   v-for="item in work" :class="addClass(item)">
        <div v-html="item.svg_back"  v-if="item.mobile_uniq === true"></div>
        <div v-html="item.svg_num"  v-if="item.mobile_uniq === true"></div>

        <span class="hw-head other " :class="{'not_uniq' : item.mobile_uniq === false}">{{ item.title }}</span>
        <span class="hw-desc other reinvest first " v-html="item.desc">
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>